import React from 'react';

// Import award images
import award1 from '../images/award/award_1.png';
import award2 from '../images/award/award_2.png';

const AwardsSection = () => {
  const awards = [
    {
      title: 'Presented statue of Ram Ji to Yogi Adityanath Ji',
      description: 'Honored for the exquisite craftsmanship and cultural significance of the Ram statue presented to the Chief Minister of Uttar Pradesh.',
      image: award1
    },
    {
      title: 'Meeting with Ram Sutar Ji',
      description: 'Renowned sculptor and creator of the Statue of Unity, recognized for his contributions to Indian art and sculpture.',
      image: award2
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Awards & Recognition
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Celebrating artistic excellence and the impact of our work on communities and culture
          </p>
        </div>

        {/* Awards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {awards.map((award, index) => (
            <div
              key={index}
              className="award-card group overflow-hidden rounded-2xl bg-white shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col"
            >
              {/* Award Image - Unobscured & Fully Visible */}
              <div className="relative h-64 sm:h-72 overflow-hidden bg-gray-100">
                <img
                  src={award.image}
                  alt={award.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    e.target.src = '/images/placeholder.jpg';
                  }}
                />
              </div>

              {/* Text Content Below Image */}
              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors duration-300">
                    {award.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {award.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;